import React, { Component } from 'react'
import { Container } from 'semantic-ui-react'
import { Provider } from 'react-redux'
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom'
import ReactGA from 'react-ga';

import './App.css'
import store from './modules/main/store'

import ProjectsGrid from './modules/projects/ProjectsGrid'
import MainMenu from './modules/menu/container'
import about from './modules/about/About'
import project from './modules/project/Project'
import contact from './modules/contact/Contact'
import ScrollToTop from './components/ScrollToTop'

const projects = () => (
  <Container>
    <ProjectsGrid/>
  </Container>
)

class App extends Component {
  constructor (props){
    super(props)
    ReactGA.initialize('UA-115526081-1');
  }

  fireTracking(){
    ReactGA.pageview(window.location.pathname);
  }

  render () {
    return (
      <Provider store={store}>
        <Router onUpdate={this.fireTracking}>
          <ScrollToTop>
            <div>
              <MainMenu/>
              <Route exact path={'/'} component={projects}/>
              <Route path={'/about'} component={about}/>
              <Route path={'/projects/:idNum'} component={project}/>
              <Route path={'/contact'} component={contact}/>
            </div>
          </ScrollToTop>
        </Router>
      </Provider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js